import { useState } from "react";

const PREFIX = "csd-";

/**
 * Like useState but backed by sessionStorage so form data survives tab
 * unmounts (Create Shipment tabs have keepAlive=false).
 *
 * @param {string|null} instanceId  Unique tab instance id from shipmentSlice.
 *   Pass null when no persistence is needed (the hook degrades to plain state).
 * @param {*} initial  Initial value, used on first mount when no stored draft exists.
 */
export function useCreateShipmentDraft(instanceId, initial) {
  const key = instanceId ? `${PREFIX}${instanceId}` : null;

  const [state, setState] = useState(() => {
    if (!key) return initial;
    try {
      const raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : initial;
    } catch {
      return initial;
    }
  });

  const set = (updater) => {
    setState((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      if (key) {
        try { sessionStorage.setItem(key, JSON.stringify(next)); } catch {}
      }
      return next;
    });
  };

  const clear = () => {
    if (key) {
      try { sessionStorage.removeItem(key); } catch {}
    }
    setState(initial);
  };

  return [state, set, clear];
}
